import { render, staticRenderFns } from "./product-attr-edit.vue?vue&type=template&id=5661d5e7&scoped=true"
import script from "./product-attr-edit.vue?vue&type=script&lang=js"
export * from "./product-attr-edit.vue?vue&type=script&lang=js"
import style0 from "./product-attr-edit.vue?vue&type=style&index=0&id=5661d5e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5661d5e7",
  null
  
)

export default component.exports